import React, { Fragment } from 'react'
import Navbar from '../../component/Other/Navbar'
import Head from '../../component/Page/Head'
import Footer from '../../component/Other/Footer'

const Imprint = () => {
    return (
        <Fragment>
            <div className="overflow-hidden">
                <div className="position-relative">
                    <Navbar />
                    <Head title={"Impressum"} to={"Impressum"} />
                </div>

                <main>
                    <section>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-md-9 col-lg-7">
                                    <div className="mb-4">
                                        <h2 className="semi-bold font__size--24 text__24-1024 mb-2">
                                            Angaben gemäß § 5 DDG
                                        </h2>
                                        <address className="normal font__size--20 text__20-1024 color__gray-1 mb-0">
                                            Wero flowers GmbH<br />
                                            Düsseldorfer Landstraße 183–189<br />
                                            47249 Duisburg<br />
                                            Deutschland
                                        </address>
                                    </div>

                                    <div className="mb-4">
                                        <h2 className="semi-bold font__size--24 text__24-1024 mb-2">
                                            Vertreten durch
                                        </h2>
                                        <p className="normal font__size--20 text__20-1024 color__gray-1 mb-0">
                                            Geschäftsführerin: Weronika Jedynak
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h2 className="semi-bold font__size--24 text__24-1024 mb-2">
                                            Kontakt
                                        </h2>
                                        <p className="normal font__size--20 text__20-1024 color__gray-1 mb-0">
                                            Telefon: <a href="tel:+4915208599686">+49 1520 8599686</a><br />
                                            E-Mail: <a href="mailto:weroflowers@gmx.de">weroflowers@gmx.de</a>
                                        </p>
                                    </div>

                                    <div className="mb-4">
                                        <h2 className="semi-bold font__size--24 text__24-1024 mb-2">
                                            Registereintrag
                                        </h2>
                                        <p className="normal font__size--20 text__20-1024 color__gray-1 mb-0">
                                            Registergericht: Amtsgericht Duisburg<br />
                                            Handelsregisternummer: HRB 28877
                                        </p>
                                    </div>

                                    <div>
                                        <h2 className="semi-bold font__size--24 text__24-1024 mb-2">
                                            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
                                        </h2>
                                        <p className="normal font__size--20 text__20-1024 color__gray-1 mb-0">
                                            Weronika Jedynak<br />
                                            Düsseldorfer Landstraße 183–189<br />
                                            47249 Duisburg
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </div>
        </Fragment>
    )
}

export default Imprint
